import $ from "jquery";
import axios from "@/vendors/axios";
const html = document.querySelector("html");
const locale = html.getAttribute("lang");
const Job = {
    init: async () => {
        const $jobs = document.querySelectorAll(".job");
        if ($jobs.length === 0)
            return;
        const countries = await Job.fetchCountries();
        Job.loop($jobs, countries);
        Job.careersModalShow();
    },
    fetchCountries: async () => {
        const { data } = await axios.get(`/api/jobs/countries`);
        return data;
    },
    fetchCountriesJobs: async (element, country) => {
        const vacancy = element.querySelector("[name='vacancy']");
        const jobCard = element.querySelector(".job-card");
        let selectedData = [];
        if (country !== "") {
            const { data } = await axios.get(`/api/jobs/countries/${country}`);
            selectedData = data;
        }
        if (selectedData.length > 0) {
            $(jobCard).slideDown();
            element.classList.add("is-expanded");
            Job.renderJobs(jobCard, selectedData);
            return;
        }
        $(jobCard).slideUp();
        element.classList.remove("is-expanded");
    },
    renderJobs: (element, data) => {
        const list = element.querySelector(".job-card-list");
        let listItems = "";
        data.map((item) => {
            listItems += `
      <li>
        <h3>${item.title[locale]}</h3>
        <div class="job-card-row">
          <div class="job-card-description">
            ${item.content[locale]}
          </div>
        </div>

        ${item.email !== null
                ? `<div class="job-card-footer job-row">
            <h5>Email Us your CV</h5>
            <button 
              type="button" 
              data-bs-toggle="modal"
              data-bs-target="#modal-careers"
              data-form-title="${item.title[locale]}"
              class="btn btn-primary">
              Apply Now
            </button>
          </div>`
                : ""}
      </li>`;
        });
        list.innerHTML = listItems;
    },
    renderCountries: (element, countries) => {
        const defaultOption = element.querySelector("option").innerHTML;
        element.innerHTML = `
      <option value="" selected>${defaultOption}</option>
      ${countries.map((country) => `<option value="${country.key}">${country.name}</option>`)}
    `;
    },
    loop: (elements, countries) => {
        elements.forEach((element) => {
            const country = element.querySelector('[name="country"]');
            Job.renderCountries(country, countries);
            // @ts-ignore
            $(country).on("select2:select", (event) => {
                const { value } = event.target;
                Job.fetchCountriesJobs(element, value);
            });
        });
    },
    careersModalShow: () => {
        const modal = document.getElementById('modal-careers');
        modal.addEventListener('show.bs.modal', function (event) {
            const button = event.relatedTarget;
            const { formTitle } = button.dataset;
            const inputSubject = modal.querySelector('[name="subject"]');
            inputSubject.classList.add('focus');
            inputSubject.value = `Job Application - ${formTitle}`;
            if (typeof formTitle === "undefined") {
                inputSubject.value = 'CV Submission for Consideration';
            }
        });
    }
};
export default Job;
